<!-- prestations ocashe -->
<div class="col" *ngIf="false">
	<div class="border border-light border-5 rounded bg-light h-100">
		<div class="row mt-2 mb-3 text-center justify-content-center">
			<i class="bi bi-calendar-check-fill fs-1" aria-hidden="true"></i>
			<span
				*ngIf="listAppointments.length > 0"
				class="theme-main-color fw-bold fs-4"
			>
				Nouvelle{{ manyNewAppointments ? 's' : '' }} prestation{{
					manyNewAppointments ? 's' : ''
				}}
				en attente
			</span>
			<span
				*ngIf="listAppointments.length === 0"
				class="theme-main-color fw-bold fs-4"
			>
				Pas de nouvelles prestations
			</span>
		</div>
		<div class="row mb-3">
			<div class="row" *ngFor="let appointment of listAppointments">
				<div class="row ms-2">
					<span class="theme-main-color">
						Nouvelle prestation à placer du
						<span class="theme-main-color fw-bold"
							>{{ appointment.startDate }} au {{ appointment.endDate }}</span
						>
						pour
						<span class="theme-main-color fw-bold">{{
							appointment.beneficiaire.firstName +
								' ' +
								appointment.beneficiaire.lastName
						}}</span>
						<!-- Bouton de planification avec icône -->
						<a
							class="btn theme-main-color-button mt-2 ms-2 align-baseline"
							(click)="navigateToAddForm(appointment)"
							role="button"
						>
							<i class="bi bi-calendar-plus"></i> Planifier
						</a>
					</span>
				</div>
			</div>
		</div>
	</div>
</div>
